import React, { Component } from "react";
import { Grid, Hidden } from "@material-ui/core";
import { connect } from "react-redux";

import style from "./style";

class BannerButtonsComp extends Component {
  state = {
    openSignUpDrawer: false,
    chefHover: false,
    dinerHover: true,
  };

  handleChef = () => {
    this.props.history.push("/chef");
  };

  handleDiner = () => {
    this.props.history.push("/diner");
  };

  toggleSignUpDrawer = () => {
    /*this.props.history.push({
      pathname: '/sign-up',
      search: `?type=${this.props.type}`,
      state: { type: this.props.type }
    });*/
    this.props.history.push(this.props.type === 'chef' ? '/sign-up-chef' : '/sign-up');
  };

  render() {
    return (
      <div>
        {this.props.type === "landing" && (
          <Hidden xsDown>
            <Grid container direction="row" justify="center">
              <Grid
                item
                xs={7}
                md={5}
                className="btnBanner"
                style={!this.state.dinerHover ? style.bannerButtonInverted : style.bannerButton}
                onClick={this.handleDiner}
                onMouseOver={() => this.setState({dinerHover: true})}
                //onMouseOut={() => this.setState({dinerHover: false})}
              >
                <img
                  src={!this.state.dinerHover ? "/images/37481-inverted.webp" : "/images/37481.webp"}
                  alt="diner"
                  title="I am Diner"
                  style={style.bannerBtnImg}
                />
                <span data-test-id={"iamdiner-id"} style={style.btnBannerTxt}>I'm a Diner</span>
              </Grid>
              <Grid
                item
                xs={7}
                md={5}
                style={this.state.chefHover ? style.bannerButton : style.bannerButtonInverted}
                className="btnBanner"
                onClick={this.handleChef}
                onMouseOver={() => this.setState({chefHover: true, dinerHover: false})}
                onMouseOut={() => this.setState({chefHover: false, dinerHover: true})}
              >
                <img
                  src={this.state.chefHover ? "/images/483841-inverted.webp" : "/images/483841.webp"}
                  alt="chef"
                  title="I am Chef"
                  style={style.bannerBtnImg}
                />
                <span data-test-id={"iamchef-id"} style={style.btnBannerTxt}>I'm a Chef</span>
              </Grid>
            </Grid>
          </Hidden>
        )}
        {this.props.type === "landing" && (
          <Hidden smUp>
            <Grid container direction="row" justify="center" style={style.btnGridMobile}>
            <Grid
                item
                xs={7}
                md={5}
                className="btnBanner mbl-ml-0"
                style={!this.state.dinerHover ? style.bannerButtonInverted : style.bannerButton}
                onClick={this.handleDiner}
                onMouseOver={() => this.setState({dinerHover: true})}
                //onMouseOut={() => this.setState({dinerHover: false})}
              >
                <img
                  src={!this.state.dinerHover ? "/images/37481-inverted.webp" : "/images/37481.webp"}
                  alt="diner"
                  title="I am Diner"
                  style={style.bannerBtnImg}
                />
                <span data-test-id={"iamdiner-id"} style={style.btnBannerTxt}>I'm a Diner</span>
              </Grid>
              <Grid
                item
                xs={7}
                md={5}
                style={style.bannerButtonInverted}
                className="btnBanner mbl-ml-0"
                onClick={this.handleChef}
              >
                <img
                  src="/images/483841.webp"
                  alt="chef"
                  title="I am Chef"
                  style={style.bannerBtnImg}
                />
                <span style={style.btnBannerTxt}>I'm a Chef</span>
              </Grid>
            </Grid>
          </Hidden>
        )}
        {this.props.type !== "landing" && (
          <Grid
            data-test-id={"getstarted-id"}
            container
            style={{ ...style.getStartedButton, ...style.singleBtn }}
            className="btnBanner"
            onClick={this.toggleSignUpDrawer}
            alignItems="center"
            justify="center"
          >
            <span>Get Started</span>
          </Grid>
        )}
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    becomeChef: state.auth.becomeChef
  };
};

const BannerButtons = connect(mapStateToProps)(BannerButtonsComp);

export default BannerButtons;
